<script>
    export let title;
    export let description;
</script>

<style>
    feature {
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        width: 35%;
        max-width: 1000px;
        margin-bottom: 10px;
        margin-left: 5px;
        margin-right: 5px;
        padding: 30px;
    }

    @media (max-width: 1000px) {
		feature {
            width: 100%;
            margin-left: 10px;
            margin-right: 10px;
		}
	}

    .featureTitle {
        font-weight: 400;
        font-size: 22px;
        text-align: left;
        margin-bottom: 15px;
        font-family: 'Roboto Slab', serif;
    }

    .featureDesc {
        font-size: 14px;
        line-height: 140%;
        font-weight: 700;
        color: #98D4FF;
    }

</style>

<feature data-aos="fade-in">
    <div class="featureTitle">{title}</div>
    <div class="featureDesc">{description}</div>
</feature>